import LeaveHTMLPreviewBalanceColumnsRender from './LeaveHTMLPreviewBalanceColumnsRender'

export default class LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender extends LeaveHTMLPreviewBalanceColumnsRender {

    constructor(withSpaces) {
        super(withSpaces)
    }

    addHeaderFirstRowCells = (fRow) => {
        this._addEmptyCellIfNeed(fRow)
        this._addSickDaysFRowCells(fRow)
    }

    addHeaderSecondRowCells = (sRow) => {
        this._addEmptyCellIfNeed(sRow)
        this._addRangeSRowCells(this.showSickInHours, sRow)
    }

    addValueCells = (row) => {
        this._addEmptyCellIfNeed(row)
        this._addBalanceValueCell(row)
        this._addBalanceValueCell(row)
    }

    getRenderSpecificCssClass = () => {
        return "oneBalance"
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/leave/LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender.js